const ALLOWED_TAGS = new Set([
  'a', 'b', 'blockquote', 'br', 'caption', 'code', 'col', 'colgroup', 'div',
  'em', 'figcaption', 'figure', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr',
  'i', 'img', 'li', 'ol', 'p', 'pre', 'span', 'strong', 'sub', 'sup',
  'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul'
]);

const GLOBAL_ATTRIBUTES = new Set(['class', 'title']);
const TAG_ATTRIBUTES: Record<string, Set<string>> = {
  a: new Set(['href', 'target', 'rel']),
  col: new Set(['span']),
  img: new Set(['src', 'alt', 'width', 'height']),
  ol: new Set(['start']),
  td: new Set(['colspan', 'rowspan']),
  th: new Set(['colspan', 'rowspan', 'scope'])
};

function isSafeUrl(value: string, allowDataImage = false): boolean {
  const normalized = Array.from(value.trim())
    .filter((character) => {
      const code = character.charCodeAt(0);
      return code > 31 && code !== 127 && !/\s/.test(character);
    })
    .join('')
    .toLowerCase();
  if (normalized.startsWith('#') || normalized.startsWith('/') || normalized.startsWith('./') || normalized.startsWith('../')) {
    return true;
  }
  if (allowDataImage && /^data:image\/(?:gif|png|jpeg|webp);base64,/.test(normalized)) {
    return true;
  }
  return /^(?:https?:|mailto:|tel:)/.test(normalized);
}

/** Sanitize administrator-authored rich text before passing it to Vue's v-html. */
export function sanitizeHtml(value: unknown): string {
  if (typeof value !== 'string' || value.length === 0) {
    return '';
  }

  const document = new DOMParser().parseFromString(value, 'text/html');
  const elements = Array.from(document.body.querySelectorAll('*'));

  elements.forEach((element) => {
    const tag = element.tagName.toLowerCase();
    if (!ALLOWED_TAGS.has(tag)) {
      element.replaceWith(...Array.from(element.childNodes));
      return;
    }

    Array.from(element.attributes).forEach((attribute) => {
      const name = attribute.name.toLowerCase();
      if (!GLOBAL_ATTRIBUTES.has(name) && !TAG_ATTRIBUTES[tag]?.has(name)) {
        element.removeAttribute(attribute.name);
      }
    });

    if (element.hasAttribute('href') && !isSafeUrl(element.getAttribute('href') || '')) {
      element.removeAttribute('href');
    }
    if (element.hasAttribute('src') && !isSafeUrl(element.getAttribute('src') || '', tag === 'img')) {
      element.removeAttribute('src');
    }
    if (tag === 'a' && element.getAttribute('target') === '_blank') {
      element.setAttribute('rel', 'noopener noreferrer');
    }
  });

  return document.body.innerHTML;
}
